import React, { useEffect, useState } from "react";
import { Form, Offcanvas, Spinner, Table } from "react-bootstrap";
import {
  NoDataFoundTable,
  PageLoader,
} from "../../../Components/NoDataFoundTable/NoDataFoundTable";
import { useParams } from "react-router";
import { cdiscManagementService } from "../../../APIServices/CDISC/cdiscManagementService";

const PullLibraryMetadata = ({
  Show,
  Hide,
  Title,
  tableRef,
  onMouseDown,
  getStudyFormLibraryData,
}) => {
  const { studyId } = useParams();
  const [buttonLoader, setButtonLoader] = useState(false);
  const [loading, setLoading] = useState(false);
  const [pullLibraryData, setPullLibraryData] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  const getClientFormLibraryForPull = async () => {
    try {
      setLoading(true);
      const data = await cdiscManagementService.getClientFormLibraryForPull(
        studyId
      );
      const rows = data?.data || [];
      setPullLibraryData(rows);
      setSelectedRows([]);
      setSelectAll(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (studyId) {
      getClientFormLibraryForPull();
    }
  }, [studyId]);

  const handleSelectAll = (e) => {
    const checked = e.target.checked;
    setSelectAll(checked);
    if (checked) {
      const allIds = pullLibraryData.map((item) => item.formId);
      setSelectedRows(allIds);
    } else {
      setSelectedRows([]);
    }
  };

  const handleRowSelect = (id) => {
    setSelectedRows((prev) => {
      const isSelected = prev.includes(id);
      const updated = isSelected ? prev.filter((x) => x !== id) : [...prev, id];
      setSelectAll(updated.length === pullLibraryData.length);
      return updated;
    });
  };

  const pullStudyFormLibrary = async () => {
    setButtonLoader(true);
    const userData = {
      formIds: selectedRows,
      studyId,
    };
    const data = await cdiscManagementService.pullStudyFormLibrary(userData);
    if (data?.statusCode === 200) {
      Hide();
      getStudyFormLibraryData();
      getClientFormLibraryForPull();
      setSelectedRows([]);
    }
    setButtonLoader(false);
  };

  return (
    <Offcanvas show={Show} onHide={Hide} style={{ width: 575 }} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{Title}</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body className="p-0">
        {loading ? (
          <PageLoader />
        ) : pullLibraryData.length === 0 ? (
          <NoDataFoundTable MSG="Form library not found!." />
        ) : (
          <>
            <Table ref={tableRef} className="m-0 custom-table" hover striped>
              <thead className="position-sticky top-0 bg-white">
                <tr>
                  <th
                    onMouseDown={(e) => onMouseDown(e, 0)}
                    style={{ width: 45 }}
                    className="text-center"
                  >
                    <Form.Check
                      type="checkbox"
                      checked={selectAll}
                      onChange={handleSelectAll}
                    />
                  </th>
                  <th onMouseDown={(e) => onMouseDown(e, 1)}>Form Name</th>
                </tr>
              </thead>
              <tbody>
                {pullLibraryData.map((item) => {
                  const rowId = item.formId;
                  return (
                    <tr key={rowId}>
                      <td className="text-center">
                        <Form.Check
                          type="checkbox"
                          checked={selectedRows.includes(rowId)}
                          onChange={() => handleRowSelect(rowId)}
                        />
                      </td>
                      <td>{item?.name}</td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </>
        )}
      </Offcanvas.Body>

      <div className="p-2 border-top text-end">
        <button
          className="updateProfile"
          disabled={buttonLoader || selectedRows.length === 0}
          onClick={pullStudyFormLibrary}
        >
          {buttonLoader ? (
            <div className="hstack gap-2">
              <Spinner size="sm" /> Pulling...
            </div>
          ) : (
            "Pull Form"
          )}
        </button>
      </div>
    </Offcanvas>
  );
};

export default PullLibraryMetadata;
